var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex company-content-wrapper",
      staticStyle: { height: "100%" }
    },
    [
      _c("CompanyEditMenu", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c("div", { staticClass: "l-bg-white" }, [
        _vm.step === "companies-info"
          ? _c(
              "div",
              [
                _c("companies-info", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-map"
          ? _c(
              "div",
              [
                _c("companies-map", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-settings"
          ? _c(
              "div",
              [
                _c("companies-settings", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-pricing"
          ? _c(
              "div",
              [
                _c("companies-pricing", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-availability"
          ? _c(
              "div",
              [
                _c("companies-availability", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "website-details"
          ? _c(
              "div",
              [
                _c("companies-profile", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "web-quote"
          ? _c(
              "div",
              [
                _c("companies-web-quote", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-email"
          ? _c(
              "div",
              [
                _c("companies-emails", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "getting-started"
          ? _c(
              "div",
              [
                _c("companies-getting-started", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-licence"
          ? _c(
              "div",
              [
                _c("companies-licence", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "companies-tier"
          ? _c(
              "div",
              [
                _c("companies-tier", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "billing-info"
          ? _c(
              "div",
              [
                _c("companies-billing-info", {
                  attrs: { company: _vm.company, type: "edit" },
                  on: { saved: _vm.saved }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83bdda5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83bdda5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesEdit.vue
// module id = null
// module chunks = 